import { render } from "./ImprimirCertificado.vue?vue&type=template&id=b41d5c3a&scoped=true"
import script from "./ImprimirCertificado.vue?vue&type=script&lang=js"
export * from "./ImprimirCertificado.vue?vue&type=script&lang=js"

import "./ImprimirCertificado.vue?vue&type=style&index=0&id=b41d5c3a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41d5c3a"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QImg});
